import { useMutation } from "@tanstack/react-query";
import { addImageToMedia } from "../services/images.service";

export const useAddImageToMedia = () => {
  return useMutation({
    mutationFn: addImageToMedia,
  });
};
